const locale = {
	// #region Courses fields
	DETAILS_COURSES_FIELD_TITLE: 'Titolo',
	DETAILS_COURSES_FIELD_DATE_START: 'Data inizio',
	DETAILS_COURSES_FIELD_DATE_END: 'Data fine',
	DETAILS_COURSES_FIELD_SKILL: 'Competenza',
	DETAILS_COURSES_FIELD_LENGTH_HOURS: 'Durata (ore)',
	DETAILS_COURSES_FIELD_TAGS: 'Tag',
	DETAILS_COURSES_FIELD_WARNING: 'Warning',
	DETAILS_COURSES_FIELD_BLOCKED: 'Bloccato',
	// #endregion

	// #region Details Courses buttons
	DETAILS_HEADER_BUTTON_NEW_USER: 'Aggiungi Partecipante',
	// #endregion

	// #region Courses Misc (Dialog, etc.)
	TAB_USERS_COURSES: 'Partecipanti',
	VIEW_ITEM_NO_SKILL: 'Competenza non specificata',
	COURSES_BUTTON_REMOVE_ATTENDER: 'Rimuovi dal Corso',
	DIALOG_ADD_ATTENDER_TITLE: 'Aggiungi Partecipante',
	DIALOG_ADD_COURSE_TITLE: 'Aggiungi Corso',
	DIALOG_REMOVE_ATTENDER_TITLE: 'Sei sicuro? '
	// #endregion
};

export default locale;
